import request from "@/utils/request";

const baseUrl = '/front/blog/comment'


// 查询文章评论
export function getArticleCommentList(articleId) {
    return request({
        url: baseUrl + '/article/' + articleId,
        method: 'get'
    })
}

// 添加文章评论
export function commentArticle(data) {
    return request({
        url: baseUrl,
        method: 'post',
        data: data
    })
}
